import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import { innerbanner } from "../Settings/Config";
import ContentLoader from "react-content-loader";
import axios from "axios";
import { format } from "date-fns";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Sidebar from "./Sidebar";

import AscentisRewards from "./AscentisRewards";

class Myaccount extends Component {
  constructor(props) {
    super(props);
    const customerID = localStorage.getItem("customerID") ?? "";
    this.state = {
      trigerCart: false,
      globalSettings: "",
    };
  }
  componentWillReceiveProps(PropsDt) {
    if (this.state.globalSettings !== PropsDt.globalSettings) {
      const settings = PropsDt.globalSettings;
      const companyEnableAscentisCRM = settings?.companyEnableAscentisCRM ?? false;
      this.setState({
        globalSettings: PropsDt.globalSettings,
        enableAscentisCRM: companyEnableAscentisCRM,
      });
    }
  }
  updateStateValue = (field, value) => {
    this.setState({ [field]: value });
  };

  render() {
    return (
      <div className="cover">
        <Header
          trigerCart={this.state.trigerCart}
          updateStateValue={this.updateStateValue.bind(this)}
        />
        <div className="inner-banner">
          <img src={innerbanner} alt="image" />
          <div className="inner-caption">Reward Points</div>
        </div>
        <div className="innerpage myaccount-pages">
          <div className="container">
            <div className="dashboard-main">
              <Sidebar {...this.props} active="rewards" />
              {this.state.enableAscentisCRM===true && 
                <AscentisRewards {...this.props} />
              }
            </div>
          </div>
        </div>
        <Footer
          {...this.props}
          updateStateValue={this.updateStateValue.bind(this)}
        />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var globalSettings = "";
  if (Object.keys(state.settings).length > 0) {
    if (state.settings[0].status === "ok") {
      globalSettings = state.settings[0].result;
    }
  }
  return {
    globalSettings: globalSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateTopProps,
  mapDispatchToProps
)(withRouter(Myaccount));
